const config = {
    backendUrl:process.env.REACT_APP_BASE_URL || 'http://localhost:8000',
    defaultCurrency:process.env.REACT_APP_DEFAULT_CURRENCY || 'DH'
};

export default config;
